"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AVKCamera = exports.NCameraInput = exports.NCameraMount = exports.NCameraType = void 0;
var NModel_1 = require("./NModel");
var NCameraLocation_1 = require("./NCameraLocation");
var NCameraConfiguration_1 = require("./NCameraConfiguration");
var NCameraType;
(function (NCameraType) {
    NCameraType[NCameraType["PTZ"] = 0] = "PTZ"; /* Physical cameras. */
    NCameraType[NCameraType["DigitalInput"] = 1] = "DigitalInput"; /* Wire inputs. */
})(NCameraType = exports.NCameraType || (exports.NCameraType = {}));
var NCameraMount;
(function (NCameraMount) {
    NCameraMount[NCameraMount["VirtualDevice"] = 0] = "VirtualDevice"; /* Not a real camera, but an HDMI input. No mount. */
    NCameraMount[NCameraMount["FrontFixed"] = 1] = "FrontFixed"; /* Front (fixed) OR camera. */
    NCameraMount[NCameraMount["OverheadBoom"] = 2] = "OverheadBoom"; /* Overhead (boom) table camera. */
})(NCameraMount = exports.NCameraMount || (exports.NCameraMount = {}));
var NCameraInput;
(function (NCameraInput) {
    NCameraInput[NCameraInput["PhysicalLens"] = 0] = "PhysicalLens"; /* Not an HDMI input at all but a phyiscal camera. */
    NCameraInput[NCameraInput["WireOneHDMIInput"] = 1] = "WireOneHDMIInput"; /* Left HDMI port. */
    NCameraInput[NCameraInput["WireTwoHDMIInput"] = 2] = "WireTwoHDMIInput"; /* Right HDMI port. */
    NCameraInput[NCameraInput["WireThreeVideoInput"] = 3] = "WireThreeVideoInput";
    NCameraInput[NCameraInput["WireFourVideoInput"] = 4] = "WireFourVideoInput";
})(NCameraInput = exports.NCameraInput || (exports.NCameraInput = {}));
var AVKCamera = /** @class */ (function (_super) {
    __extends(AVKCamera, _super);
    function AVKCamera() {
        var _this = _super.call(this) || this;
        _this._cameraIdentifier = '';
        _this._type = 0;
        _this._mount = 0;
        _this._input = 0;
        _this._name = '';
        _this._configuration = new NCameraConfiguration_1.NCameraConfiguration();
        _this._location = new NCameraLocation_1.NCameraLocation();
        return _this;
    }
    AVKCamera.universalModelType = function () {
        return 'io.avail.models.camera.v2';
    };
    Object.defineProperty(AVKCamera.prototype, "cameraIdentifier", {
        get: function () {
            return this._cameraIdentifier;
        },
        set: function (value) {
            this._cameraIdentifier = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AVKCamera.prototype, "type", {
        get: function () {
            return this._type;
        },
        set: function (value) {
            this._type = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AVKCamera.prototype, "mount", {
        get: function () {
            return this._mount;
        },
        set: function (value) {
            this._mount = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AVKCamera.prototype, "input", {
        get: function () {
            return this._input;
        },
        set: function (value) {
            this._input = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AVKCamera.prototype, "location", {
        get: function () {
            return this._location;
        },
        set: function (value) {
            this._location = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AVKCamera.prototype, "configuration", {
        get: function () {
            return this._configuration;
        },
        set: function (value) {
            this._configuration = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AVKCamera.prototype, "name", {
        get: function () {
            return this._name;
        },
        set: function (value) {
            this._name = value;
        },
        enumerable: false,
        configurable: true
    });
    return AVKCamera;
}(NModel_1.NModel));
exports.AVKCamera = AVKCamera;
//# sourceMappingURL=AVKCamera.js.map